export const SINGLE_LINE_COMMENT_BOILERPLATE_SIZE = 2; // i.e. '//'.length
